module.exports = {
}


// WEBPACK FOOTER //
// ./src/pages/forget/i18n/locale.en.js